import React, { useState } from 'react'

import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { useHandleAtsCallback } from '@/react-query/ats/integration'

interface ConnectModalProps {
  isOpen: boolean
  onClose: () => void
}

export const ConnectModal: React.FC<ConnectModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [apiKey, setApiKey] = useState('')
  const connectMutation = useHandleAtsCallback()

  const handleSubmit = async () => {
    const trimmed = apiKey.trim()
    if (!trimmed) return
    await connectMutation.mutateAsync({ apiKey: trimmed })
    setApiKey('')
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Connect Ashby</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={2}>
          <Text fontSize="sm" color="gray.600" mb={4}>
            Paste your Ashby API key to connect your workspace. You can create
            one in{' '}
            <Link
              href="https://app.ashbyhq.com/admin/api-keys"
              isExternal
              color="blue.500"
            >
              Ashby → Admin → API Keys
            </Link>
            .
          </Text>
          <FormControl>
            <FormLabel fontSize="sm">Ashby API key</FormLabel>
            <Input
              type="password"
              placeholder="ashby_live_..."
              value={apiKey}
              onChange={(event) => setApiKey(event.target.value)}
              autoComplete="off"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="brand-solid"
            onClick={handleSubmit}
            isDisabled={!apiKey.trim()}
            isLoading={connectMutation.isPending}
            loadingText="Connecting..."
          >
            Connect
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
